"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceTypeEnum;
(function (ServiceTypeEnum) {
    ServiceTypeEnum["SEARCH"] = "search";
    ServiceTypeEnum["SEARCH_BOOST"] = "searchBoost";
    ServiceTypeEnum["BROWSE"] = "browse";
    ServiceTypeEnum["ATTRIBUTES"] = "attributes";
})(ServiceTypeEnum = exports.ServiceTypeEnum || (exports.ServiceTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmljZS10eXBlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW51bXMvc2VydmljZS10eXBlLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFZLGVBS1g7QUFMRCxXQUFZLGVBQWU7SUFDekIsb0NBQWlCLENBQUE7SUFDakIsK0NBQTRCLENBQUE7SUFDNUIsb0NBQWlCLENBQUE7SUFDakIsNENBQXlCLENBQUE7QUFDM0IsQ0FBQyxFQUxXLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBSzFCIn0=